<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>设置</el-breadcrumb-item>
        <el-breadcrumb-item>问题反馈</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">问题反馈</h2>
        </div>
      </div>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">反馈列表</p>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           width="70"
                           label="ID"
                           align="center">
          </el-table-column>
          <el-table-column prop="nickname"
                           width="120"
                           show-overflow-tooltip
                           label="用户名称"
                           align="center">
          </el-table-column>
          <el-table-column prop="uid"
                           width="70"
                           label="用户ID"
                           align="center">
          </el-table-column>
          <el-table-column prop="title"
                           label="标题"
                           align="center"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="content"
                           label="内容"
                           align="center"
                           width="400"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="contact"
                           label="反馈图片"
                           align="center"
                           width="300">
            <template slot-scope="scope"
                      v-if="scope.row.pictures.length">
              <el-image style="width: 50px; height: 50px;margin:0px 10px;"
                        v-for="(item,index) in scope.row.pictures.map(v=>{ return v.picture_url })"
                        :key="index"
                        :src="item"
                        :preview-src-list="[item]">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="mobile"
                           label="联系方式"
                           align="center">
          </el-table-column>
          <el-table-column prop="source"
                           label="来源"
                           align="center">
            <template slot-scope="scope">
              {{ formateClient(scope.row.source_id)}}
            </template>
          </el-table-column>
          <el-table-column prop="ip"
                           label="上传时间"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD HH:mm:ss")
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <!--     <div
      class="test-div"
      v-html="content"
    >

    </div> -->
  </div>
</template>

<script>
import { feedbacklist } from '@/api/index'
import { join } from '../../lego/config/menu.config'

export default {
  components: {},
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      text: ' When I come across a good article in reading newspapers, I often want to cut and keep it. But just as I am about to do so I find the article on the $$ side is as much interesting. It may be a discussion of the way to $$ in good health, or $$ about how to behave and conduct oneself in society. If I cut the front article, the opposite one is likely to $$ damage, leaving out half of it or keeping the text $$ the title. Therefore, the scissors would $$ before they start, $$ halfway done when I find out the 8 result.',
      content: '',
    }
  },
  created() {
    let array = this.text.split(' ')
    /*    array = array.forEach((item, index) => {
         if (item == '$$') {
           item = item.replace(item, '999')
           console.log(item);
         }
       }) */
    this.content = array
      .map((v, i) => {
        if (v == '$$') {
          return `<input type='text' class='input-calss'/>`
        } else {
          return v
        }
      })
      .join(' ')
    console.log(array.join(' '))

    this.fetchRecordtList()
    this.$store.dispatch('getClientList')
  },
  methods: {
    fetchRecordtList() {
      feedbacklist(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchRecordtList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchRecordtList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchRecordtList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchRecordtList()
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    formateClient(val) {
      if (val) {
        return this.$store.state.clientList.find((v) => {
          return v.id == val
        }).name
      } else {
        return '无'
      }
    },
  },
}
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.test-div {
  border: solid;
  height: 800px;
}
</style>
<style lang="less">
</style>
